<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadConcentFormData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex  md9 xs12>

        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="dataloaded && userDataLoaded && !deleting && deviatingAdvices.length > 0" class="mt-5">
      <div class="content-box">
        <v-card>
          <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              dense
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <div class="header-edit-button">
              
            </div>
          </v-card-title>

          <v-data-table
            :headers="headersDeviatingAdvices"
            :items="deviatingAdvices"
            :search="search"
            :itemsPerPage.sync="queuePages"
            v-model="selected"
            hide-default-footer
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item}">
              <tr @click="viewDeviatingAdvice(item)">
                <td class="text-xs-left">{{ item.timestamp | moment("DD-MM-YYYY - H:mm") }}u</td>
                <td class="text-xs-left">{{ item.clientName }}</td>
                <td class="text-right">
                  <v-btn icon small><v-icon>mdi-chevron-right</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" class="text-center" v-if="dataloaded && userDataLoaded && !deleting && deviatingAdvices.length == 0">
      <p>Er zijn nog geen toestemmingsformulieren.</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="addNewMembership()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe toestemmingsformulier toe. </span>
        </v-tooltip>
      </div>
    </div>

    <!-- / Add & View Client Afwijkend Advies Dialog (BEAUTY BY ROOS) \ -->
    <v-dialog v-model="deviatingAdvice.dialog" max-width="700" scrollable>
      <v-card width="100%">
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 v-if="deviatingAdvice.type == 'new'" style="color:white">Toestemmingsformulieren toevoegen</h2>
          <h2 v-else style="color:white">Toestemmingsformulieren van {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="removeClientDeviatingAdvice(deviatingAdvice.id)" v-if="deviatingAdvice.type == 'view' && (userRole == 'admin' ||  userRole == 'superadmin' )" >
            <v-icon dark color="white">mdi-delete</v-icon>
          </v-btn>

          
          <v-btn icon dark @click="closeDeviatingAdviceDialog()" :disabled="deviatingAdvice.uploading">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="hogans-alerts">
          <v-alert
            v-if="deviatingAdvice.feedback"
            :value="true"
            type="warning"
            style="border-radius: 0!important"
            v-html="deviatingAdvice.feedback"
          ></v-alert>
        </div>

        <v-divider></v-divider>

        <v-card-text class="pt-2">

          <p class="pt-4 mb-0">Beauty by Roos Hairextensions voert uitsluitend behandelingen uit op advies van alle Hairextensions Professionals die werkzaam zijn bij Beauty by Roos Hairextensions. Wanneer de klant een afwijkende behandeling wil bij ons in de salon is dit volledig op eigen risico en vervalt de garantie op de uitgevoerde behandeling.</p>

          <v-card color="menu" flat outlined class="pa-0">
            <h4 v-if="deviatingAdvice.type == 'new'" style="font-size: 18px; font-weight: bold" class="py-4">Selecteer afwijkende wensen van de klant</h4>
            <h4 v-else style="font-size: 18px; font-weight: bold" class="py-4">Afwijkende wensen van de klant</h4>
            <v-checkbox
              class="pa-0 ma-0"
              v-model="deviatingAdvice.deviatings"
              value="differentLength"
              label="Andere lengte gewenst dan geadviseerd"
              :disabled="deviatingAdvice.type == 'view'"
            ></v-checkbox>
            <v-checkbox
              class="pa-0 ma-0"
              v-model="deviatingAdvice.deviatings"
              value="differentColor"
              label="Andere kleur gewenst dan geadviseerd"
              :disabled="deviatingAdvice.type == 'view'"
            ></v-checkbox>
            <v-checkbox
              class="pa-0 ma-0"
              v-model="deviatingAdvice.deviatings"
              value="differentBrand"
              label="Ander merk extensions gewenst dan geadviseerd"
              :disabled="deviatingAdvice.type == 'view'"
            ></v-checkbox>
            <v-checkbox
              class="pa-0 ma-0"
              v-model="deviatingAdvice.deviatings"
              value="differentNumber"
              label="Ander aantal extensions gewenst dan geadviseerd"

              :disabled="deviatingAdvice.type == 'view'"
            ></v-checkbox>
          </v-card>

          <v-card color="background" flat outlined class="pa-3 my-4">
            <h4 style="font-size: 18px; font-weight: bold">Geadviseerd</h4>

            <v-container grid-list-md class="ma-0 pa-0" >
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex xs6>
                  <v-text-field
                    class="mt-3"
                    label="Lengte"
                    v-model="deviatingAdvice.advice.length"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Kleur"
                    v-model.trim="deviatingAdvice.advice.color"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                  </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Merk"
                    v-model="deviatingAdvice.advice.brand"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Aantal"
                    v-model="deviatingAdvice.advice.number"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                    class="mt-3"
                    label="Aanvullende opmerkingen"
                    v-model="deviatingAdvice.advice.notes"
                    required
                    outlined
                    rows="3"
                    hide-details
                    background-color="menu"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>  
          </v-card>

          <v-card color="background" flat outlined class="pa-3 my-4">
            <h4 style="font-size: 18px; font-weight: bold" >Gekozen door de klant</h4>
            <v-container grid-list-md class="ma-0 pa-0" >
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex xs6>
                  <v-text-field
                    class="mt-3"
                    label="Lengte"
                    v-model="deviatingAdvice.clientChoice.length"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Kleur"
                    v-model="deviatingAdvice.clientChoice.color"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                  </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Merk"
                    v-model="deviatingAdvice.clientChoice.brand"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Aantal"
                    v-model="deviatingAdvice.clientChoice.number"
                    required
                    dense
                    outlined
                    background-color="menu"
                    hide-details
                    class="mt-3"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    class="mt-3"
                    label="Aanvullende opmerkingen"
                    v-model="deviatingAdvice.clientChoice.notes"
                    required
                    outlined
                    hide-details
                    rows="3"
                    background-color="menu"
                    :readonly="deviatingAdvice.type == 'view'"
                    :disabled="deviatingAdvice.type == 'view'"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container> 
          </v-card>

          <v-container grid-list-md class="ma-0 mt-4 pa-0 pt-4" >
            <h4 style="font-size: 18px; font-weight: bold" >Naam en handtekening voor akkoord</h4>

            <p class="ma-0 pb-0 pt-2" v-if="deviatingAdvice.type == 'new'">Middels deze ondertekening geef ik Beauty by Roos Hairextensions toestemming om een behandeling uit te voeren die niet overeenkomt met het gegeven advies door de Hairextensions Professional van Beauty by Roos Hairextensions. Ik verklaar hierbij ook dat ik geen negatieve reviews over Beauty by Roos zal plaatsen.</p>
            <p class="ma-0 pb-0 pt-2" v-else>Middels deze ondertekening heb ik Beauty by Roos Hairextensions toestemming gegeven om een behandeling uit te voeren die niet overeenkomt met het gegeven advies door de Hairextensions Professional van Beauty by Roos Hairextensions. Ik verklaar hierbij ook dat ik geen negatieve reviews over Beauty by Roos zal plaatsen.</p>

            <div style="padding: 10px 0 0 0;">
              <p v-if="deviatingAdvice.type == 'new'" style="font-size: 14px;"><strong>Datum:</strong> {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</p>
            </div>
              
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs6>
                <v-text-field
                  label="Naam"
                  :readonly="deviatingAdvice.type == 'view'"
                  :disabled="deviatingAdvice.type == 'view'"
                  v-model.trim="deviatingAdvice.clientName"
                  required
                  outlined
                  background-color="background"
                  dense
                ></v-text-field>
                <p class="pa-0 mb-1" style="font-size: 16px;"><strong>Handtekening</strong></p>
                <div v-if="deviatingAdvice.type == 'new'">
                  <vueSignature ref="signature" :sigOption="signatureOptions" :w="'100%'" :h="'140px'" style="border: 2px solid #333; border-radius: 8px; overflow: hidden"></vueSignature> 
                  <v-btn small depressed class="my-2" @click="clearSignature">Wissen</v-btn>
                </div>
                <div v-else>
                  <v-img
                    max-width="350"
                    :src="deviatingAdvice.clientSignature"
                  ></v-img>
                </div>
              </v-flex>
            </v-layout>
          </v-container> 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :disabled="deviatingAdvice.uploading"
                  color="#8B93A6"
                  @click="closeDeviatingAdviceDialog()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  v-if="deviatingAdvice.type == 'new'" 
                  rounded
                  :loading="deviatingAdvice.uploading"
                  :disabled="deviatingAdvice.uploading"
                  :dark="!deviatingAdvice.uploading"
                  :color="companySecondaryColor"
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  @click="addClientDeviatingAdvice()"
                  >
                  Toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Add & View Client Afwijkend Advies Dialog (BEAUTY BY ROOS) / -->
  </div>
</template>


<script>
  import { bus } from "../main";
  import db from "../firebase/init";
  import _lodash from "lodash";
  import platform from 'platform'; 
  import moment from 'moment';

  export default {
    name: "DeviatingAdvice",
    data: () => ({
      activeComp: null,
      activeCompData: null,
      userDataLoaded: false,
      selectedBranchesOriginal: [],
      selectedBranches: [],
      selectedBranchesData: [],
      search: "",
      searchCompanies: "",
      selected: [],
      deleting: false,
      deleteCounter: 0,
      dataloaded: false,
      newQueueDialog: false,
      editQueueDialog: false,
      pagination: {
        rowsPerPage: "200",
        sortBy: "dateAdded.seconds",
        descending: false
      },
      deviatingAdvices: [],
      membershipsScheduled: [],
      selectedClientQueueItemOriginal: {},
      removeBookings: "",
      selected: [],
      branches: [],
      companies: [],
      queuePages: -1,
      headersDeviatingAdvices: [
        { text: "Datum", value: "timestamp", sortable: true, align: "left", width: "180px" },
        { text: "Naam", value: "clientName", sortable: false },
        { text: "", value: "edit", sortable: false, width: "100px" }
      ],
      headers: [
        {
          text: "Datum",
          align: "left",
          value: "dateAdded",
          width: "200px"
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          width: "200px"
        },
        {
          text: "Naam",
          align: "left",
          value: "lastName"
        },
        {
          text: "Vestiging",
          align: "left",
          value: "branch"
        },
        {
          text: "Bedrag",
          align: "left",
          value: "firstName"
        },
        {
          text: "Download",
          align: "left",
          value: "firstName"
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "50px",
          sortable: false
        },
      ],
      deviatingAdvice: {
          type: null,
          dialog: false,
          feedback: null,
          deviatings: new Array(),
          advice: {
            length: null,
            color: null,
            brand: null,
            number: null,
            notes: null
          },
          clientChoice: {
            length: null,
            color: null,
            brand: null,
            number: null,
            notes: null
          },
          timestamp: null,
          clientName: null,
          uploading: false,
          clientSignature: null,
        },
      previewMembershipDialog: false,
      previewMembership: new Object(),
      membershipTypes: [
        {
          id: "new",
          name: 'Nieuw (3 maanden)'
        },
        {
          id: "extension",
          name: 'Verlenging (3 maanden)'
        },
        {
          id: "newFour",
          name: 'Nieuw (4 maanden)'
        },
        {
          id: "extensionFour",
          name: 'Verlenging (4 maanden)'
        }
      ],
    }),

    created() {
      this.loadUserComp();
    },

    methods: {
      loadUserComp() {
        this.dataloaded = false;
        this.userDataLoaded = false;
        let userCompanies = this.userCompanies;
        this.companies = [];
        let counter = 0

        new Promise((resolve, reject)=>{
          this.userCompanies.forEach(company=>{
            db.collection("companies").doc(company).get()
              .then(doc => {
                let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
                if (dossierPackage >= 0) {
                  let company = doc.data();
                  company.id = doc.id;
                  this.companies.push(company);
                }
                counter++
                if(counter == this.userCompanies.length){
                  resolve()
                }
              })
          })
        })
        .then(()=>{
          // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
          if(this.userRole == 'superadmin'){
            // Super Admins have access to multiple companies 
            let selectedCompany = window.localStorage.getItem('selectedCompany')

            // Check if a selected company is set in the Local Storage
            if(selectedCompany){
              
              // Check if the selected company is an option
              let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

              // Selected company is an option, set activeComp
              if(selectedCompanyIndex >= 0){
                this.activeCompData = this.companies[selectedCompanyIndex];
                this.activeComp = this.companies[selectedCompanyIndex].id;
                console.log("selectedCompanyIndex: ", selectedCompanyIndex)
                this.loadConcentFormData();
                this.userDataLoaded = true;
              } 
              // Selected company is no option, set first company as activeComp 
              else{
                this.activeCompData = this.companies[0];
                this.activeComp = this.companies[selectedCompanyIndex].id;
                window.localStorage.setItem('selectedCompany', this.companies[0].id)
                this.loadConcentFormData();
                this.userDataLoaded = true;
              }
            }
            // No selected company is set 
            else {
              this.activeCompData = this.companies[0];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadConcentFormData();
              this.userDataLoaded = true;
            }
          }

          // Regular users have 1 company, just get the first
          else {
            this.activeCompData = this.companies[0];
            this.activeComp = this.companies[0].id;
            this.loadConcentFormData();
            this.userDataLoaded = true;
          }
        })
      },

      viewDeviatingAdvice(item){
        this.deviatingAdvice.type = "view";
        this.deviatingAdvice.timestamp = item.timestamp;
        this.deviatingAdvice.deviatings = item.deviatings;
        this.deviatingAdvice.clientChoice = item.clientChoice
        this.deviatingAdvice.advice = item.advice;
        this.deviatingAdvice.id = item.id;
        this.deviatingAdvice.clientName = item.clientName;
        this.deviatingAdvice.clientSignature = item.clientSignature
        this.deviatingAdvice.dialog = true;
      },

      closeDeviatingAdviceDialog(){
        this.deviatingAdvice.dialog = false;
        if(this.deviatingAdvice.type == "new"){ // Alleen wissen als handtekening pad getoond wordt.
          this.clearSignature();
        }
        this.deviatingAdvice.type = "new";
        this.deviatingAdvice.deviatings = new Array();
        this.deviatingAdvice.advice.length = null;
        this.deviatingAdvice.advice.color = null;
        this.deviatingAdvice.advice.brand = null;
        this.deviatingAdvice.advice.number = null;
        this.deviatingAdvice.advice.notes = null;
        this.deviatingAdvice.clientChoice.length = null;
        this.deviatingAdvice.clientChoice.color = null;
        this.deviatingAdvice.clientChoice.brand = null;
        this.deviatingAdvice.clientChoice.number = null;
        this.deviatingAdvice.clientChoice.notes = null;
        this.deviatingAdvice.clientName = null;
        this.deviatingAdvice.id = null;
        this.deviatingAdvice.uploading = false;
        this.deviatingAdvice.feedback = null;
        
      },

      loadBranches() {
        if(this.companies.length > 1){
          this.companies.forEach(company => {
            if(company.id == this.activeComp){
              this.activeCompData = company;
            }
          });
        }
        
        db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
      },

      getBranchName(branche){
        let name = '';
        this.branches.forEach(element => {
          if(element.id == branche){
            name = element.branchName
          }
        });
        return name;
      },   


      updateData(){
        this.dataloaded = false;
        this.loadConcentFormData();
      },

      async loadConcentFormData(){
        this.loadBranches();
        await db.collection("deviatingAdvices")
        .where("companyId", "==", this.activeComp)
        .orderBy("timestamp", "desc")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let deviatingAdvice = doc.data();
            deviatingAdvice.id = doc.id;
            this.deviatingAdvices.push(deviatingAdvice);
          });
        })
        this.dataloaded = true;
      },

      updateData() {
        this.loadSelectedBranchesData();
      },

      addNewMembership(){
        bus.$emit("openMembershipDialog");
      },

      editClientQueueItem(item) {
        this.selectedClientQueueItem = Object.assign({}, item);
        this.selectedClientQueueItem.queueEndDatePicker  = moment.unix(item.queueEndDate.seconds).format("YYYY-MM-DD");
        this.selectedClientQueueItemOriginal = _.cloneDeep(this.selectedClientQueueItem);
        this.editQueueDialog = true;
      },

      goToDossier(salonhubId){
        this.$router.push('/dossier?id='+ salonhubId)
      },
    },

    computed: {
      demoMode(){
        return this.$store.state.demoMode;
      },
      userCompanies() {
        return this.$store.state.userCompanies;
      },
      userBranches() {
        return this.$store.state.userBranches;
      }, 
      userCompany() {
        return this.$store.state.userCompany;
      },
      userFirstName() {
        return this.$store.state.userFirstName;
      },
      userLastName() {
        return this.$store.state.userLastName;
      },
      userRole() {
        return this.$store.state.userRole;
      },
      companyPrimaryColor() {
        return this.$store.state.companyPrimaryColor;
      },
      companySecondaryColor() {
        return this.$store.state.companySecondaryColor;
      },
      filteredCompanies(){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      },
      theme(){
        return (this.$vuetify.theme.dark) ? 'dark' : 'light'
      },
      branchesChanged() {
        if (
          _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
        ) {
          return false;
        } else {
          return true;
        }
      },
      branchesWidth(){
        if(this.companies.length > 1 && !this.demoMode){
          return "md6"
        }
        else{
          return "md9"
        }
      }
    }
  };
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
